import React from "react";
import ReactDOM from "react-dom/client";
import { store } from "./redux/store";
import { Provider } from "react-redux";
//import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@hooks/useAuth";
import SEO from "./views/pages/misc/SEO";
// ** Live testing
import "./configs/settings";
import { HelmetProvider } from "react-helmet-async";
//mock db

// import './@mock'
import { reportBrowserError } from "@api";
try {
  const helmetContext = {};
  window.reportBrowserError = reportBrowserError;
  ReactDOM.createRoot(
    document.getElementById("root")
  ).render(
    <BrowserRouter basename="/probate">
      <AuthProvider>
        <Provider store={store}>
          <HelmetProvider context={helmetContext}>
            <SEO
              title={"Probate eService"}
              description={
                "Submit an application to deal with a deceased person's estate under a will, Probate eService"
              }
            />
            <App />
          </HelmetProvider>
        </Provider>
      </AuthProvider>
    </BrowserRouter>
  );
} catch (error) {
  console.error("Error when render: " + error);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
